import { join } from "node:path";
import { requireResolve } from "./requireResolve.js";
const getSvelteMajor = async () => {
  const { readFile } = await import("node:fs/promises");
  const packageJSONPath = requireResolve("svelte/package.json", join(process.cwd(), "package.json"));
  const { version } = JSON.parse(await readFile(packageJSONPath, "utf8"));
  const major = Number.parseInt(version.split(".")[0]);
  if (Number.isNaN(major)) {
    throw new Error(`Unable to parse svelte's installed version number: "${version}"`);
  }
  return major;
};
export {
  getSvelteMajor
};
//# sourceMappingURL=getSvelteMajor.js.map
